export const orientations = ["portrait", "landscape", "square"] as const;

export const fps = 30;

export function aspectData(orientation: (typeof orientations)[number]) {
  if (orientation === "square") {
    return {
      ratioText: "1:1",
      style: { height: 72, width: 72 },
      videoResolution: { height: 960, width: 960 },
    };
  }

  if (orientation === "landscape") {
    return {
      ratioText: "16:9",
      style: { height: 64, width: 96 },
      videoResolution: { height: 720, width: 1280 },
    };
  }

  return {
    ratioText: "9:16",
    style: { height: 96, width: 64 },
    videoResolution: { height: 1280, width: 720 },
  };
}
